import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import actions from "../../calendar-settings/actions";
import { GTM_ID, GA4EVENT } from "../../calendar-common/constants";
import NotificationSoundButton from "../../common/components/NotificationSoundButton";
const translations = {
    vi: () =>
        import(/*webpackChunkName: 'sound-alert-vi'*/ "../translations/vi"),
    ar: () =>
        import(/*webpackChunkName: 'sound-alert-ar'*/ "../translations/ar"),
    de: () =>
        import(/*webpackChunkName: 'sound-alert-de'*/ "../translations/de"),
    en: () =>
        import(/*webpackChunkName: 'sound-alert-en'*/ "../translations/en"),
    es: () =>
        import(/*webpackChunkName: 'sound-alert-es'*/ "../translations/es"),
    fr: () =>
        import(/*webpackChunkName: 'sound-alert-fr'*/ "../translations/fr"),
    id: () =>
        import(/*webpackChunkName: 'sound-alert-id'*/ "../translations/id"),
    ru: () =>
        import(/*webpackChunkName: 'sound-alert-ru'*/ "../translations/ru"),
    tr: () =>
        import(/*webpackChunkName: 'sound-alert-tr'*/ "../translations/tr"),
    "zh-cht": () =>
        import(
            /*webpackChunkName: 'sound-alert-zh-cht'*/ "../translations/zh-cht"
        ),
    "zh-cn": () =>
        import(
            /*webpackChunkName: 'sound-alert-zh-cn'*/ "../translations/zh-cn"
        ),
    fa: () =>
        import(/*webpackChunkName: 'sound-alert-fa'*/ "../translations/fa"),
    pt: () =>
        import(/*webpackChunkName: 'sound-alert-pt'*/ "../translations/pt"),
    cs: () =>
        import(/*webpackChunkName: 'sound-alert-cs'*/ "../translations/cs"),
};
class SoundAlert extends Component {
    componentWillMount() {
        translations[
            this.props.locale ? this.props.locale.toLowerCase() : "en"
        ]().then((t) => {
            this.setState({ translations: t.default });
        });
    }
    render(
        { config, translate, onCheckboxChanged, notificationSoundOn },
        { translations }
    ) {
        if (!translations) return null;

        return (
            <div>
                <h3 class="fxs_headline_small">
                    {translations.SoundAlert}
                    <NotificationSoundButton
                        gtmIdSoundOn={
                            config.tracking && GTM_ID.CONFIGURATION_SOUND_ON
                        }
                        gtmIdSoundOff={
                            config.tracking && GTM_ID.CONFIGURATION_SOUND_OFF
                        }
                        GA4IdSoundOn={
                            config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_SOUND_ON
                        }
                        GA4IdSoundOff={
                            config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_SOUND_OFF
                        }
                        g4Name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        activated={notificationSoundOn}
                        toggleSound={() => onCheckboxChanged()}
                    />
                </h3>

                <p class="fxs_entryPlain_txt">
                    {translations.SoundAlert_Summary}
                </p>
            </div>
        );
    }
}

export default connectWithTranslations("settings, config", actions)(SoundAlert);
